// extracted by extract-css-chunks-webpack-plugin
module.exports = {"message-settings-wrapper":"setting-messages__message-settings-wrapper--3VU5g","messageSettingsWrapper":"setting-messages__message-settings-wrapper--3VU5g"};